import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingCheckoutStepNavigationEvent implements GATrackingEvent {

  constructor(private label: string, private data: any) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CheckoutStepNavigationClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      category: GaTrackingEventCategory.Navigation,
      label: this.label,
      gtmCustom: {
        action:  this.data.action
      }
    };
  }
}
